import Schema, { required } from 'AppReact/schema';
import { makeReadyColumn } from 'types';

const dropdownOption = {
  id: required(['string', 'integer']),
  label: required('string'),
  color: required('string'),
}

export default {
  isVisible: Schema('boolean', 'primitive', { defaultValue: false }),
  title: Schema('string', 'primitive-nullable', { defaultValue: null }),
  inputVal: Schema('string', 'primitive-nullable', { defaultValue: '' }),
  searchTerm: Schema('string', 'primitive-nullable', { defaultValue: '' }),
  placeholder: Schema('string', 'primitive-nullable', { defaultValue: null }),
  selectedOptionIds: Schema(['string', 'integer'], 'array', { defaultValue: [] }),
  options: Schema(dropdownOption, 'array', { defaultValue: [] }),
  pageNumber: Schema('integer', 'primitive', { defaultValue: 1 }),
  noTagIds: Schema(['string', 'integer'], 'array', { defaultValue: [] }),
  makeReadyCategory: Schema(makeReadyColumn, 'object', { defaultValue: {} }),
}